export const SalaryDecisionVI = {
    "salaryDecision" : {
        "headingAdd": "Tạo mới quyết định điều chỉnh lương",
        "headingUpdate": "Cập nhật quyết định điều chỉnh lương",
        "placeHolder": {
            "salaryDecisionCode": "QD001",
            "decisionDate": "dd/mm/yyyy",
            "positionDecision": "Chọn cấp công ty",
            "effectDate": "dd/mm/yyyy",
            "employee": "Chọn nhân viên",
            "reason": "Nhập lý do",
            "fromDate": "dd/mm/yyyy",
            "note": "Nhập ghi chú",
            "salaryTypes": "Chọn hình thức lương",
            "allowances": "Chọn phụ cấp",
            "money": "Số tiền"
        },
        "label": {
            "salaryDecisionCode": "Số quyết định",
            "decisionDate": "Ngày quyết định",
            "positionDecision": "Cấp ra quyết định",
            "effectDate": "Ngày hiệu lực",
            "employee": "Nhân viên",
            "decSalaryAllowances": "Lương và phụ cấp:",
            "reason": "Lý do",
            "fromDate": "Từ ngày",
            "note": "Ghi chú",
            "salaryTypes": "Hình thức lương",
            "decPrimaryMoney": "Số tiền",
            "allowances": "Phụ cấp",
            "decMoneyBenefit": "Số tiền",
            "oldSalary": "Tiền lương cũ",
            "oldAllowance": "Phụ cấp cũ",
            "status": "Trạng thái",
            "pending": "Tìm người duyệt",
            "approved": "Đã duyệt",
            "reject": "Từ chối",
            "trashed": "Loại bỏ"
        },
        "detail": {
            "heading": "Chi tiết quyết định tăng/giảm lương",
            "generalInformation": "Thông tin chung",
            "oldSalaryInformation": "Thông tin lương phụ cấp cũ",
            "newSalaryInformation": "Thông tin lương mới",
            "newAllowanceInformation": "Thông tin phụ cấp mới"
        },
        "message": {
            "effectDateException": "Ngày hiệu lực không được trước ngày quyết định",
            "fromDateException": "Từ ngày không được trước ngày quyết định",
            "allowanceDuplicate": "Không được chọn trùng loại phụ cấp",
            "salaryTypeDuplicate": "Không được chọn trùng hình thức lương",
            "add": "Thêm thành công",
            "update": "Cập nhật thành công",
            "error": "Lỗi",
            "required": {
                "salaryDecisionCode": "Vui lòng nhập số quyết định",
                "decisionDate": "Vui lòng chọn ngày quyết định",
                "positionDecisionId": "Vui lòng chọn cấp ra quyết định",
                "effectDate": "Vui lòng chọn ngày hiệu lực",
                "employeeId": "Vui lòng chọn nhân viên",
                "fromDate": "Vui lòng chọn từ ngày",
                "salaryTypes": "Vui lòng chọn hình thức lương",
                "allowances": "Vui lòng chọn phụ cấp",
                "money": "Vui lòng nhập số tiền"
            }
        }
    }
}